var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { styled, css } from '@creditas-ui/system';
import { getTypography, variant } from '@creditas-ui/utilities';
import { Flex } from '@creditas-ui/layout';
import { Inlinelink as InlineLink } from '@creditas-ui/inline-link';

var base = _ref => {
  var {
    theme: {
      tooltip
    }
  } = _ref;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", " ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n  display: flex;\n  flex-direction: column;\n  white-space: nowrap;\n"])), tooltip('base.paddingY'), tooltip('base.paddingX'), tooltip('base.shadow'), tooltip('base.borderRadius'));
};

var themeStyles = _ref2 => {
  var {
    theme: {
      tooltip
    }
  } = _ref2;
  return variant({
    prop: 'variant',
    variants: {
      dark: {
        backgroundColor: tooltip('dark.backgroundColor')
      },
      light: {
        backgroundColor: tooltip('light.backgroundColor')
      }
    }
  });
};

var variantStyles = _ref3 => {
  var {
    theme: {
      tooltip
    }
  } = _ref3;
  return variant({
    prop: 'variant',
    variants: {
      dark: {
        color: tooltip('dark.color')
      },
      light: {
        color: tooltip('light.color')
      }
    }
  });
};

var variantPositions = _ref4 => {
  var {
    theme: {
      tooltip
    }
  } = _ref4;
  return variant({
    prop: 'local',
    variants: {
      over: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        bottom: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n        padding-bottom: ", ";\n      "])), tooltip('base.marginTop')),
      bottom: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n        padding-top: ", ";\n      "])), tooltip('base.marginBottom')),
      right: css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        top: 50%;\n        left: 100%;\n        padding-left: ", ";\n        transform: translateY(-50%);\n      "])), tooltip('base.marginLeft')),
      left: css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        right: 100%;\n        top: 50%;\n        transform: translateY(-50%);\n        padding-right: ", ";\n      "])), tooltip('base.marginRight'))
    }
  });
};

var Wrapper = styled(Flex)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n\n  .tooltip-class {\n    opacity: 0;\n    position: absolute;\n    transition: 1s;\n    pointer-events: none;\n  }\n\n  :hover {\n    .tooltip-class {\n      opacity: 1;\n      pointer-events: all;\n    }\n  }\n\n  ", "\n"])), _ref5 => {
  var {
    focus
  } = _ref5;
  return focus && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      .tooltip-class {\n        opacity: 1;\n        pointer-events: all;\n      }\n    "])));
});
var Link = styled(InlineLink)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n"])), variantStyles);
var Content = styled('small')(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  ", "\n"])), variantStyles);
var TooltipContainer = styled(Flex)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", ";\n"])), variantPositions);
var TooltipElement = styled(Flex)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n"])), base, themeStyles, getTypography('bodyXsRegular'));
export { TooltipContainer, TooltipElement, Wrapper, Link, Content };
//# sourceMappingURL=Tooltip.style.js.map